import type { ApiError } from "./types";

let csrfToken = "";
export class RequestError extends Error { constructor(public detail: ApiError, public status:number){ super(detail.message) } }
export function setCSRF(value:string){ csrfToken=value }
export async function api<T>(path:string, init:RequestInit={}):Promise<T>{
  const headers = new Headers(init.headers);
  if(init.body && !(init.body instanceof FormData)) headers.set("Content-Type","application/json");
  if(init.method && init.method!=="GET" && csrfToken) headers.set("X-CSRF-Token",csrfToken);
  const response=await fetch(`/api/v1${path}`,{...init,headers,credentials:"same-origin"});
  const payload=await response.json().catch(()=>({error:{code:"invalid_response",message:"O servidor retornou uma resposta inválida."}}));
  if(!response.ok) throw new RequestError(payload.error ?? {code:"request_failed",message:"A solicitação falhou."},response.status);
  return payload.data as T;
}
export const post=<T>(path:string,body:unknown)=>api<T>(path,{method:"POST",body:JSON.stringify(body)});
export const del=<T>(path:string,body?:unknown)=>api<T>(path,{method:"DELETE",...(body===undefined?{}:{body:JSON.stringify(body)})});
export const patch=<T>(path:string,body:unknown)=>api<T>(path,{method:"PATCH",body:JSON.stringify(body)});
export const put=<T>(path:string,body:unknown)=>api<T>(path,{method:"PUT",body:JSON.stringify(body)});
export const postForm=<T>(path:string,body:FormData)=>api<T>(path,{method:"POST",body});
